<template>
  <div class="mobile-agenda-card">
    <header class="card-top-detail">
      <span class="card-status-marker" :class="statusMarkerClassName" />
      <div class="top-detail-inner" @click="expandCard">
        <h4 class="top-title">
          <i
            class="title-icon fas fa-fw fa-chevron-down"
            :class="titleIconClassName"
          />
          <span class="title-label">{{title}}</span>
        </h4>

        <div class="top-meta">
          <div class="meta-item">
            <i class="meta-item-icon fas fa-fw fa-hashtag" />
            <span class="meta-item-label">{{chargeNumber}}</span>
          </div>
          <div class="meta-item">
            <i class="meta-item-icon fas fa-fw fa-calendar-alt" />
            <span class="meta-item-label">{{date}}</span>
          </div>
        </div>
      </div>
    </header>
    <SlideUpDown
      :active="isExpanded"
      :duration="350"
      class="card-center-panel"
    >
      <div class="card-center-panel-inner">
        <div class="panel-inner-left">
          <div v-if="contactName" class="contact-details -name">
            <i class="contact-details-icon fas fa-fw fa-user" />
            <div class="contact-details-label">{{contactName}}</div>
          </div>
          <div v-if="contactPhone" class="contact-details -phone">
            <i class="contact-details-icon fas fa-fw fa-flip-horizontal fa-phone" />
            <div class="contact-details-label">{{contactPhone}}</div>
          </div>
        </div>
        <div class="panel-inner-right">
          <div class="contact-address" v-html="contactAddress" />
        </div>
      </div>
    </SlideUpDown>
    <footer class="card-footer-buttons">
      <BfButton
        class="footer-button"
        variant="secondary"
        tag="router-link"
        :to="{
          name: 'incidencia',
          query: {
            chargeId: relatedChargeId,
          },
        }"
      >
        <i class="footer-button-icon fas fa-exclamation-circle" /> Incidencia
      </BfButton>
      <BfButton
        class="footer-button"
        variant="secondary"
        tag="router-link"
        :to="{
          name: 'uploadDocuments',
          params: {
            from: $route.name,
          },
          query: {
            chargeId: relatedChargeId
          },
        }"
      >
        <i class="footer-button-icon fas fa-image" /> Fotos
      </BfButton>
      <BfButton
        class="footer-button -right"
        :disabled="!canComplete"
        @click="onCompleteVisitClick"
      >
        Completar
      </BfButton>
    </footer>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';
import { get } from '@/utils';

export default {
  name: 'Card',

  props: {
    cardData: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    isExpanded: true,
  }),

  methods: {
    expandCard() {
      this.isExpanded = !this.isExpanded;
    },

    onCompleteVisitClick() {
      if (this.canComplete) {
        this.$emit('click-complete');
      }
    },
  },

  computed: {
    relatedCharge() {
      return get(this.cardData, ['encargo'], {});
    },

    title() {
      return get(this.cardData, ['solicitante_nombre'], '');
    },

    titleIconClassName() {
      return {
        '-expanded': this.isExpanded,
      };
    },

    chargeNumber() {
      return get(this.cardData, ['codigo_encargo'], '');
    },

    date() {
      const date = get(this.cardData, ['fecha'], '');
      const time = get(this.cardData, ['hora'], '');

      return `${date} ${time}`;
    },

    contactName() {
      return get(this.cardData, ['contacto'], '');
    },

    contactPhone() {
      return get(this.relatedCharge, ['contacto_telefono'], '');
    },

    contactAddress() {
      const address = get(this.relatedCharge, ['inmueble_direccion'], '');
      const town = get(this.relatedCharge, ['inmueble_poblacion'], '');
      const province = get(this.relatedCharge, ['inmueble_provincia'], '');
      const postcode = get(this.relatedCharge, ['inmueble_codigopostal'], '');

      const addressLine = address ? `${address}<br/>` : '';
      const townLine = `${town ? `${town} ` : ''}${postcode ? `(${postcode})` : ''}<br />`;
      const provinceLine = province || '';

      return `${addressLine}${townLine}${provinceLine}`;
    },

    /**
 * Este método valida que antes de cerrar una visita exista un documento del tipo foto (Cat 3). Solo esta para tasadores por
 * lo que no hace falta validar el rol en esta parte.
 */
    hasDocumentation() {
      const documents = get(this.relatedCharge, ['documentos_asociados'], []);
      let img = false;
      documents.forEach((document) => {
        if (document.categoria === 3) {
          img = true;
        }
      });
      return img;
      // return documents.length > 0;
    },

    hasIncidents() {
      const status = get(this.relatedCharge, ['estado'], '');

      return status.includes('D');
    },

    relatedChargeId() {
      return get(this.relatedCharge, ['id'], '');
    },

    statusMarkerClassName() {
      if (this.hasIncidents) {
        return '-red';
      }

      if (!this.hasDocumentation) {
        return '-blue';
      }

      return '';
    },

    canComplete() {
      return this.hasDocumentation;
    },
  },

  components: {
    SlideUpDown,
  },
};
</script>

<style lang="scss" scoped>
.mobile-agenda-card {
  background: var(--bf-color-light);
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);

  .card-top-detail {
    display: flex;
    align-items: center;
    padding: 18px 10px 15px;
  }

  .card-status-marker {
    display: block;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #348e42;
    margin-right: 12px;

    &.-red {
      background: #f04747;
    }

    &.-blue {
      background: #0085ff;
    }
  }

  .top-detail-inner {
    flex: 1;
    cursor: pointer;

    .top-title,
    .top-meta .meta-item {
      font-size: 14px;
      line-height: 1.15;
    }

    .top-title {
      color: var(--bf-color-dark);
      font-weight: var(--bf-font-weight-semibold);
      margin: 0 0 10px;
      display: flex;
      align-items: flex-start;

      .title-icon {
        margin-right: 5px;
        position: relative;
        top: 1px;
        transition: transform 0.35s ease;

        &.-expanded {
          transform: rotate(-180deg);
        }
      }

      .title-label {
        display: block;
      }
    }

    .top-meta {
      .meta-item {
        color: var(--bf-color-grey);
        display: flex;
        line-height: 1.1;

        &-icon {
          font-size: 15px;
          display: block;
          margin-right: 5px;
        }

        &-label {
          flex: 1;
        }

        &:not(:last-child) {
          margin-bottom: 7px;
        }
      }
    }
  }

  .card-center-panel {
    color: var(--bf-color-light);
    background: var(--bf-color-primary);

    &-inner {
      padding: 22px 10px;
      display: flex;
    }

    .panel-inner-left,
    .panel-inner-right {
      width: calc(50% - 10px);
    }

    .panel-inner-left {
      margin-right: 20px;

      .contact-details {
        display: flex;
        align-items: center;
        font-size: 16px;

        &-icon {
          margin-right: 8px;
        }

        &-label {
          font-weight: var(--bf-font-weight-semibold);
        }

        &.-phone {
          font-size: 13px;

          .contact-details-icon {
            margin-right: 10px;
          }
        }

        &:not(:last-of-type) {
          margin-bottom: 4px;
        }
      }
    }

    .panel-inner-right {
      .contact-address {
        font-size: 13px;
        line-height: 18px;
      }
    }
  }

  .card-footer-buttons {
    padding: 15px 10px 16px;
    display: flex;
    align-items: center;

    .footer-button {
      white-space: nowrap;

      &:not(.-right) {
        margin-right: 6px;
      }

      &.-right {
        margin-left: auto;
      }

      &-icon {
        margin-right: 3px;
      }
    }
  }

  &:not(:last-child) {
    margin-bottom: 14px;
  }
}
</style>
